export default "__VITE_ASSET__wkrloOpO__"